module.exports = __webpack_public_path__ + "static/img/5.daf5fc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/eng/5.png
// module id = Yrov
// module chunks = 0